// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"3604274b","208":"5c1d2c51","236":"7d29adce","353":"c66d2905","512":"b2b9873b","549":"ae2b81b0","813":"0fe4ec41"}[chunkId] + ".chunk.js";
};